
/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IPermission } from "../../../models/Permission/PermissionContract";
import { getAllPermissions } from "../../../services/permissions";
import { showErrorAction } from "../../error/errorActionCreator";
import { getAllPermissionAction } from "./permissionActionCreator";
import interpolateString from '../../../utility/stringInterpolation';
import { ERROR } from "./types";

export const getPermissions = async (dispatch: Function) => {
  let permissions: IPermission[] = [];
  try {
    permissions = await getAllPermissions();
    dispatch(getAllPermissionAction(permissions));
  } catch (_error) {
    const errorMessage = {
      message: interpolateString([ERROR])
    };
    permissions = [];
    dispatch(getAllPermissionAction(permissions));
    dispatch(showErrorAction(errorMessage));
  }
};